import React from 'react';
import cn from 'classnames';
import LoginPanel from '../LoginPanel';
import gradientBG from '@app/img/onboarding/gradient_bg.png';
import styles from './Overlay.module.scss';

export default function LoginOverlay({
  userMessage,
  copyAfterMessage,
  className,
}: {
  userMessage?: string;
  copyAfterMessage?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={styles.overlay}>
      <div className={styles.bgImageContainer}>
        <img src={gradientBG} className={styles.bgImage} />
      </div>
      <LoginPanel
        userMessage={userMessage}
        className={cn(styles.loginPanel, className)}
        copyAfterMessage={copyAfterMessage}
      />
    </div>
  );
}
